import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import config from '../views/config.vue'
import openIndex from '../views/openIndex.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/configg',
    name: 'config',
    component: config
  },
  {
    path: '/signUpOpen',
    name: 'signUpOpen',
    component: openIndex
  },
]

const router = new VueRouter({
  routes
})

export default router
